// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextRecaptchaV3 from "next-recaptcha-v3";
import * as MediaQuery$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as ModalContext$PorterinFeature from "../../../../contexts/modal-context/ModalContext.mjs";
import * as AddressContext$PorterinFeature from "../../../../contexts/address-context/AddressContext.mjs";
import * as RecaptchaContext$PorterinFeature from "../../../../contexts/recpatcha-context/RecaptchaContext.mjs";
import * as FareEstimateContextV1$PorterinFeature from "../../../../contexts/fare-estimate-context/FareEstimateContextV1.mjs";
import * as FareEstimateResultStateV1$PorterinFeature from "../../../../containers/fare-estimate-v1/view/components/modals/FareEstimateResultStateV1.mjs";
import * as FareEstimateResultFormInterfaceV1$PorterinFeature from "../../../lead-flow/view/component/result-form/FareEstimateResultFormInterfaceV1.mjs";

function useHook(param) {
  var match = FareEstimateContextV1$PorterinFeature.useFareEstimateContext(undefined);
  var set_is_retry = match.set_is_retry;
  var is_retry = match.is_retry;
  var query_params = match.query_params;
  var set_fare_result = match.set_fare_result;
  var match$1 = AddressContext$PorterinFeature.useAddressContext(undefined);
  var set_is_serviceable_dropoff = match$1.set_is_serviceable_dropoff;
  var set_is_serviceable_pickup = match$1.set_is_serviceable_pickup;
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 560px)");
  var match$2 = React.useState(function () {
        return FareEstimateResultStateV1$PorterinFeature.initialFormState(query_params);
      });
  var match$3 = React.useState(function () {
        
      });
  var setPreviousResponse = match$3[1];
  var recaptcha_execute = NextRecaptchaV3.useReCaptcha();
  var recaptcha_context = RecaptchaContext$PorterinFeature.useRecaptchaContext(undefined);
  var match$4 = ModalContext$PorterinFeature.useModalContext(undefined);
  var toggleModal = match$4.toggleModal;
  var form = FareEstimateResultFormInterfaceV1$PorterinFeature.Form.useForm(match$2[0], (function (output, callbacks) {
          Curry._1(set_fare_result, {
                TAG: /* Loading */0,
                _0: undefined
              });
          Curry._1(set_is_serviceable_dropoff, true);
          Curry._1(set_is_serviceable_pickup, true);
          FareEstimateResultStateV1$PorterinFeature.onFormSubmit(undefined, undefined, output, callbacks, query_params, recaptcha_execute, setPreviousResponse, citySelectedContext.category, isDesktop, recaptcha_context, true);
          Curry._1(toggleModal, undefined);
        }));
  React.useEffect((function () {
          if (is_retry) {
            Curry._1(form.submit, undefined);
            Curry._1(set_is_retry, false);
          }
          
        }), [is_retry]);
}

export {
  useHook ,
}
/* react Not a pure module */
